import React from 'react'
import  './loadingContainer.css'

const LoadingContainer = () => {
  return (
    <div className='loading-container'>
         <div className="content">
	<div className="pill">
		<div className="medicine">
			<i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i>
		</div>
		<div className="side"></div>
		<div className="side"></div>
	</div>
</div>
    </div> 
  )
}

export default LoadingContainer